import type { ChangelogEntry } from "../types";

/** Nettside som valgfritt felt i «Ny kunde», og på kundekortet uten Brønnøysund. */
export const NETTSIDE_NY_KUNDE_2026_10: ChangelogEntry = {
  id: "2026-10-25-nettside-ny-kunde",
  date: "2026-10-25",
  title: "Legg inn nettside når du oppretter en kunde",
  summary: "«Ny kunde» har fått et valgfritt felt for nettside, som fylles ut fra Brønnøysund og vises på kundekortet, også for utenlandske kunder.",
  sections: [
    {
      heading: "Kunder",
      minRole: "user",
      items: [
        {
          title: "Nettside i «Ny kunde»",
          kind: "nytt",
          featureFlag: "feature_crm_signaler",
          body: "Velger du et treff fra Brønnøysund, fylles nettsiden inn når registeret har en. Ellers skriver du den selv, for eksempel firma.no. Den lagres under «Overvåkning» på kundekortet, men overvåkningen står av til kunden blir varm eller medium.",
        },
        {
          title: "Nettside på kundekortet uten Brønnøysund",
          kind: "forbedret",
          featureFlag: "feature_crm_signaler",
          body: "Kundekortet viste bare nettsiden fra Brønnøysund. Nå vises nettsiden fra «Overvåkning» når registeret ikke har noen, som for utenlandske kunder.",
        },
      ],
    },
  ],
};
